import React, { useState, useEffect, useContext } from "react";
import { MenuItem, Select, withStyles, makeStyles } from "@material-ui/core";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  getDropdownpData,
  meterAlertsCall,
} from "../model/e_meter_alert_service";
import { Skeleton } from "@material-ui/lab";
import { store } from "../../../helpers/store";
import { DataContext } from "../e_alerts_notification_body";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    color: theme.palette.eRich?.base + " !important",
    fontSize: "0.8rem",
    border: "1px solid " + theme.palette.ePrimary?.base + " !important",
    borderRadius: "4px",
    padding: "5px 7px",
    background: theme.palette.whiteColor.main + "!important",
  },
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
    whiteSpace: "nowrap",
  },
  icon: {
    color: theme.palette.eDark?.base + " !important",
  },
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    color: theme.palette.eRich?.base + " !important",
    fontSize: "0.8rem",
  },
}))(MenuItem);

const useStyle = makeStyles((theme) => ({
  mobileDropdown: {
    width: "120px",
  },
}));

export default function E_Notification_Period({allData,origin, setData,setAnnLoad ,setMeterLoad,meterLoad,annLoad }) {
  const ANNOUNCEMENT_VALUE="ANNOUNCEMENT";
  const METER_VALUE="METER";
  const THRESHOLD = 'PrepaidBalanceThreshold'
  const PREPAID_VALUE="PREPAID";
  const BILL_VALUE="BILL";
  const CHARGE_VALUE="CHARGE";
  const LOWBALANCE_VALUE="LOWBALANCE";
  const MINBALANCE_VALUE="MINBALANCE";
  const classes = useStyle();
  const [record, setRecord] = useState(null);
  const [currentDisplayDropdown, setCurrentDisplay] = useState(null);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 577 });
  const [saStartDate, setsaStartDate] = useState("");
  let [startDate, setStartDate] = useState();
  let [endDate, setEndDate] = useState();
  let [announcementEndDate, setAnnouncementEndDate] = useState();
  const [acc,setAcc] = useState()
  let isPrepaidSa = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const primaryIdentifier = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  const accountId = store?.getState()?.meterDetails[primaryIdentifier];
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );
  let showAllStartDate = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_SHOW_ALL_SDATE
  );
  let customerClass = useSelector(
    (state) => state?.meterDetails?.customerClassCd
  );

  useEffect(()=>{
    let bearer =JSON.parse(localStorage.getItem('bearer'))
    if(bearer){
      setAcc(bearer?.accountNumber)
    }
  },[acc,accountId])

  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")
  useEffect(() => {
    if (showAllStartDate) {
      setsaStartDate(moment(showAllStartDate).format(dateFormat));
    }
  }, [showAllStartDate]);
  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    getContentAnchorEl: null,
  };
  useEffect(() => {
    if(i18next.language){
      store.getState().snackbar = true;
      getDropdownpData("E_ALERTS_AND_NOTIFICATION_DROPDOWN", i18next.language).then(
        (resp) => {
          setRecord(resp.data.getDropdownData);
          setCurrentDisplay(resp.data.getDropdownData[2]);
        }
      );
      store.getState().snackbar = false;
    }
  
  }, [languageCode,i18next]);
  let current = new Date();
  useEffect(() => {
    if (endDate && dateFormat) {
      setAnnouncementEndDate(
        moment(endDate)
          .add(1, "day")
          .format(dateFormat)
      );
    }
  }, [endDate]);
  const displayDropdownChange = (e) => {
    store.getState().snackbar = true;
    setCurrentDisplay({
      dropDownCode: e.target.value,
      dropDownValue: e.target.name,
    });
    if (e.target.value === "E_ALERTS_AND_NOTIFICATIONS_DD_LAST_3_months") {
      filterPeriod(3);
    } else if (
      e.target.value === "E_ALERTS_AND_NOTIFICATIONS_DD_LAST_6_months"
    ) {
      filterPeriod(6);
    } else if (
      e.target.value === "E_ALERTS_AND_NOTIFICATIONS_DD_LAST_12_months"
    ) {
      filterPeriod(12);
    } else if (e.target.value === "E_ALERTS_AND_NOTIFICATIONS_DD_SHOW_ALL") {
      setEndDate(moment(current).format(dateFormat));
      setStartDate(moment(saStartDate).format(dateFormat));
    } else if (
      e.target.value === "E_ALERTS_AND_NOTIFICATIONS_DD_PREVIOUS_YEAR"
    ) {
      setEndDate(moment().subtract(1, 'year').endOf('year').format(dateFormat));
      setStartDate(moment().subtract(1, 'year').startOf('year').format(dateFormat));
    }
    store.getState().snackbar = false;
  };

  const filterPeriod = (time) => {
    setEndDate(moment(current).format(dateFormat));
    setStartDate(
      moment(current)
        .subtract(time, "months")
        .format(dateFormat)
    );
  };
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      customerClass &&
      accountId &&
      labelReady &&
      announcementEndDate
    ) {
      setData([]);
      if (origin == ANNOUNCEMENT_VALUE) {
        setAnnLoad(true)
        meterAlertsCall(
          startDate,
          endDate,
          ANNOUNCEMENT_VALUE,
          accountId,
          customerClass,
          endDate
        )
          .then((res) => {
            setAnnLoad(false)
            let data=res?.data?.getAnnouncementList;
            data.sort(
              (a, b) =>
        new Date(b.StartDate ? b.StartDate : b.InsertedDateTime) -
        new Date(a.StartDate ? a.StartDate : a.InsertedDateTime)
            ) 
            setData([...data]);
          })
          .catch((err) => {
            setAnnLoad(false)
            return null;
          });
      } else if (origin === METER_VALUE) {
        meterAlertsCall(
          startDate,
          endDate,
          origin,
          accountId,
          customerClass,
        )
          .then((res) => {
            setData([...res?.data?.getAlerts?.Meter]);
          })
          .catch((err) => {
            return null;
          });
      } else if (origin === BILL_VALUE || origin === PREPAID_VALUE) {
        meterAlertsCall(
          startDate,
          endDate,
          "",
          accountId,
          customerClass,
        )
          .then((res) => {
            if (isPrepaidSa === "N") {
              setData([...res?.data?.getAlerts?.Bill]);
            } else {
              setData([
                {
                  title: labels("E_ACCOUNT_CHARGE"),
                  alertsData: res?.data?.getAlerts?.PrepaidAccountCharge,
                  origin: CHARGE_VALUE,
                  insideWidgetRank: 2,
                },
                {
                  title: labels("E_LOW_BALANCE"),
                  alertsData: res?.data?.getAlerts?.PrepaidLowBalance,
                  origin: LOWBALANCE_VALUE,
                  insideWidgetRank: 1,
                },
                {
                  title: labels("E_BELOW_BALANCE"),
                  alertsData: res?.data?.getAlerts?.PrepaidMinimumBalance,
                  origin: MINBALANCE_VALUE,
                  insideWidgetRank: 3,
                },
              ]);
            }
          })
          .catch((err) => {
            return null;
          });
      }else if(origin === THRESHOLD){
        setMeterLoad(true)
        meterAlertsCall(startDate,endDate,"",acc,customerClass,"")
        .then(resp=>{
          setMeterLoad(false)
          setData(resp?.data?.getAlerts?.PrepaidBalanceThreshold)
        })
        .catch(error=>{
          setMeterLoad(false)
          setData([])
        })
      }
    }
  }, [
    startDate,
    endDate,
    customerClass,
    accountId,
    labelReady,
    announcementEndDate,
    acc
  ]);
  return (
    <>
      {record && currentDisplayDropdown ? (
        <STYLED_SELECT
          name={currentDisplayDropdown?.dropDownValue}
          value={currentDisplayDropdown?.dropDownCode}
          onChange={displayDropdownChange}
          displayEmpty={true}
          IconComponent={ExpandMoreSharpIcon}
          disableUnderline={true}
          MenuProps={ddlMenuProps}
          disabled={record.length > 2 ? false : true}
          className={isTabletOrMobile ? classes.mobileDropdown : ""}
        >
          {record &&
            record.map((k) => (
              <STYLED_MENU_ITEM value={k.dropDownCode} key={k.dropDownCode}>
                {k.dropDownValue}
              </STYLED_MENU_ITEM>
            ))}
        </STYLED_SELECT>
      ) : (
        <Skeleton />
      )}{" "}
    </>
  );
}
